import {generateAsyncActionCreators} from '../core/reduxUtils';



const getHydraHomePageComponentsActionCreators = generateAsyncActionCreators(
  'GET_HYDRA_HOME_PAGE_COMPONENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getHydraHomePageLazyComponentsActionCreators = generateAsyncActionCreators(
  'GET_HYDRA_HOME_PAGE_LAZY_COMPONENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getHydraHomePageMobileComponentsActionCreators = generateAsyncActionCreators(
  'GET_HYDRA_HOME_PAGE_MOBILE_COMPONENTS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getHydraHomePageMobileLazyComponentActionCreators = generateAsyncActionCreators(
  'GET_HYDRA_HOME_PAGE_MOBILE_LAZY_COMPONENT',
  (params) => ({
    params: {
      ...params,
    },
  })
);


const actionCreators = {
  getHydraHomePageComponents: {
    ...getHydraHomePageComponentsActionCreators,
  },
  getHydraHomePageLazyComponents: {
    ...getHydraHomePageLazyComponentsActionCreators,
  },
  getHydraHomePageMobileComponents: {
    ...getHydraHomePageMobileComponentsActionCreators,
  },
  getHydraHomePageMobileLazyComponent: {
    ...getHydraHomePageMobileLazyComponentActionCreators,
  },
};

export {
  actionCreators,
  getHydraHomePageComponentsActionCreators,
  getHydraHomePageLazyComponentsActionCreators,
  getHydraHomePageMobileComponentsActionCreators,
  getHydraHomePageMobileLazyComponentActionCreators
};
